<template>
  <v-dialog v-model="open" width="700px">
    <v-card>
      <v-toolbar elevation="0">
        <v-toolbar-title class="pl-3 text--subtitle">
          <v-icon color="primary" style="padding-bottom: 2px"
            >mdi-play-circle-outline</v-icon
          >
          {{ $t('message.pages.AbTest.addVideoToTest') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <div
        class="d-flex flex-wrap mx-5 mt-1 mb-2 ml-7"
        elevation="0"
        v-if="!videoToBeAdded"
      >
        <template v-if="!isNamesTooBig">
          <v-menu offset-y max-width="250">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" icon v-bind="attrs" v-on="on">
                <v-icon class="elevation-0" color="primary"
                  >mdi-package-down</v-icon
                >
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in reducedBreadcrumbArray"
                :key="index"
                @click="handleBackTo(item)"
                dense
              >
                <v-list-item-title :title="item.id ? item.name : 'Panda'">
                  <span class="subtitle-2">
                    <v-icon class="mr-2 pb-1" color="primary">
                      {{ item.id ? 'mdi-folder-outline' : 'mdi-home' }}
                    </v-icon>
                    {{ item.id ? item.name : 'Panda' }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-icon>mdi-chevron-right</v-icon>
          <button
            v-if="!currentFolder.id"
            type="button"
            class="primary--text"
            @click="handleBackTo(lastBreadcrumbItem)"
          >
            <span class="breadcrumbTexts primary--text">
              {{ lastBreadcrumbItem.id ? lastBreadcrumbItem.name : 'Panda' }}
            </span>
          </button>
          <button v-else type="button" class="primary--text">
            <span class="breadcrumbTexts primary--text">
              {{ currentRoute.name }}
            </span>
          </button>
        </template>
        <template v-else>
          <small
            v-for="(item, i) in breadcrumbArray"
            :key="i"
            style="display: block ruby"
          >
            <button
              type="button"
              class="primary--text"
              @click="handleBackTo(item)"
            >
              <span
                class="
                  breadcrumbTexts
                  primary--text
                  text-truncate
                  d-flex
                  align-center
                  mb-2
                "
              >
                <span v-if="item.id">
                  {{ item.name }}
                </span>
                <v-icon color="primary" v-else> mdi-home </v-icon>
                <v-icon v-if="i < breadcrumbArray.length - 1 || !item.id">
                  mdi-chevron-right
                </v-icon>
                <v-icon v-else color="transparent"> mdi-chevron-right </v-icon>
              </span>
            </button>
          </small>
        </template>
      </div>

      <div
        v-if="loadings.isLoadingModalVideos"
        :style="`height: ${tableHeight - 48}px`"
        class="mx-5 ml-7"
      >
        <loading-logo :value="300" />
      </div>

      <vue-virtual-table
        v-else-if="allItems.length > 0 && !videoToBeAdded"
        class="pointerTable videoModalList"
        :class="{
          displayNone: loadings.isLoadingModalVideos,
          displayBlock: !loadings.isLoadingModalVideos,
          virtualTable: $vuetify.theme.dark,
        }"
        :config="videosTableConfig"
        :data="allItems"
        :height="tableHeight"
        :minWidth="700"
        :itemHeight="48"
      >
        <template slot-scope="scope" slot="titleCommon">
          <v-row no-gutters align="center">
            <template v-if="!!scope.row.type">
              <v-row
                no-gutters
                align="center"
                style="max-width: 100%; margin-top: 5px"
              >
                <v-icon color="#9da6fb" style="margin-right: 5px"
                  >mdi-folder-remove</v-icon
                >
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ $t('message.pages.trash.title') }}
                      <span class="pl-1 text--text caption">
                        ({{ trashbinItemsCount }})
                      </span>
                    </span>
                  </template>
                  <span>
                    {{ $t('message.pages.trash.infoText') }}
                  </span>
                </v-tooltip>
              </v-row>
            </template>
            <template v-else-if="scope.row.name">
              <v-row
                no-gutters
                align="center"
                style="max-width: 100%; margin-top: 5px"
                @click="handleClickRowModalFolder(scope.row)"
              >
                <v-icon style="margin: 0px 15px 0px 20px" color="turquisePanda"
                  >mdi-folder</v-icon
                >
                <span
                  class="text-truncate"
                  :title="scope.row.name"
                  :style="`max-width: ${getTitleWidth(scope.row)};`"
                  >{{ scope.row.name }}</span
                >
                <span class="pl-1 secondaryText--text caption">
                  {{ getInsideItemsQuantity(scope.row) }}
                </span>
                <template>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="!scope.row.drm_group_ids"
                        class="pl-1"
                        small
                        color="grey"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-lock-open
                      </v-icon>
                      <div v-else>
                        <v-icon
                          v-if="isAnyDrmGroupActive(scope.row.drm_group_ids)"
                          v-bind="attrs"
                          v-on="on"
                          class="pl-1"
                          small
                          color="turquisePanda"
                        >
                          mdi-lock
                        </v-icon>
                        <v-icon
                          v-else
                          v-bind="attrs"
                          v-on="on"
                          class="pl-1"
                          small
                          color="turquisePanda"
                        >
                          mdi-lock-open
                        </v-icon>
                      </div>
                    </template>
                    <span>
                      <v-row v-if="!scope.row.drm_group_ids" no-gutters>
                        <span
                          >Esta pasta não está relacionada a nenhum grupo de
                          segurança</span
                        >
                      </v-row>
                      <v-row
                        no-gutters
                        v-else-if="!drmGroupsLoading"
                        class="flex-column"
                      >
                        <span
                          v-for="drmGroup in scope.row.drm_group_ids"
                          :key="drmGroup.drm_group_id"
                        >
                          <span v-if="findDrmGroupById(drmGroup.drm_group_id)">
                            <div
                              v-if="drmGroup.active"
                              class="
                                mr-1
                                pa-1
                                green
                                rounded-circle
                                d-inline-block
                              "
                            />
                            <div
                              v-else
                              class="
                                mr-1
                                pa-1
                                error
                                rounded-circle
                                d-inline-block
                              "
                            />
                            <span>
                              {{ findDrmGroupById(drmGroup.drm_group_id).name }}
                            </span>
                          </span>
                        </span>
                      </v-row>
                      <v-row v-else no-gutters align="center" justify="center">
                        <span class="mr-2">Carregando...</span>
                        <v-progress-circular
                          class="mb-1"
                          size="16"
                          width="3"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-row>
                    </span>
                  </v-tooltip>
                </template>
              </v-row>
            </template>
            <template v-else-if="isBeta && scope.row.drm_group_ids">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-row
                    v-on="on"
                    v-bind="attrs"
                    no-gutters
                    align="center"
                    style="max-width: 100%; margin-top: 5px"
                    @click="
                      isAnyDrmGroupActive(scope.row.drm_group_ids)
                        ? false
                        : handleClickRowModal(scope.row)
                    "
                  >
                    <v-icon
                      style="margin: 0px 15px 0px 20px"
                      :color="
                        isAnyDrmGroupActive(scope.row.drm_group_ids)
                          ? 'grey'
                          : 'primary'
                      "
                    >
                      mdi-play-circle-outline
                    </v-icon>
                    <span
                      v-if="scope.row.status === 'CONVERTED'"
                      class="text-truncate"
                      :title="scope.row.title"
                      :style="`${getRowStyle(
                        scope.row
                      )} max-width: ${getTitleWidth(scope.row)};`"
                    >
                      {{ scope.row.title }}
                    </span>
                    <template v-if="scope.row.status === 'DRAFT'">
                      <v-tooltip
                        bottom
                        v-if="
                          Math.abs(
                            new Date(scope.row.created_at) - new Date()
                          ) /
                            36e5 >
                          3
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="red--text ml-2 noIbar caption"
                          >
                            <v-icon size="18" color="red">
                              mdi-alert-circle-outline
                            </v-icon>
                          </span>
                        </template>
                        <span>
                          {{ $t('message.processingError') }}
                          {{ $t('message.verifyFileFormat') }}
                        </span>
                      </v-tooltip>
                      <span
                        v-else
                        class="ml-2 secondaryText--text caption noIbar"
                      >
                        <v-icon>mdi-progress-upload</v-icon>
                        {{ $t('message.converting') }}...
                      </span>
                    </template>
                    <span v-if="scope.row.status === 'FAILED'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="red--text ml-2 noIbar caption"
                          >
                            <v-icon size="18" color="red">
                              mdi-alert-circle-outline
                            </v-icon>
                          </span>
                        </template>
                        <span>
                          {{ $t('message.processingError') }}
                          {{ $t('message.verifyFileFormat') }}
                        </span>
                      </v-tooltip>
                    </span>
                    <template v-if="scope.row.status === 'CONVERTING'">
                      <span
                        v-if="
                          Math.abs(
                            new Date(scope.row.created_at) - new Date()
                          ) /
                            36e5 <
                          3
                        "
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-on="on"
                              v-bind="attrs"
                              class="ml-2 text--text caption noIbar"
                            >
                              <v-icon>mdi-progress-upload</v-icon>
                            </span>
                          </template>
                          {{ $t('message.converting') }}...
                        </v-tooltip>
                      </span>
                      <span
                        v-else-if="
                          Math.abs(
                            new Date(scope.row.created_at) - new Date()
                          ) /
                            36e5 <
                          48
                        "
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-on="on"
                              v-bind="attrs"
                              class="ml-2 text--text caption noIbar"
                            >
                              <v-icon>mdi-progress-upload</v-icon>
                            </span>
                          </template>
                          {{ $t('message.longerThanUsual') }}
                          <span
                            class="primary--text pointer-click"
                            @click="openKnowMoreConverting"
                            >{{ $t('message.knowMore') }} &raquo;
                          </span>
                        </v-tooltip>
                      </span>
                      <span v-else>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                              class="red--text ml-2 noIbar caption"
                            >
                              <v-icon size="18" color="red">
                                mdi-alert-circle-outline
                              </v-icon>
                              {{ $t('message.processingError') }}
                            </span>
                          </template>
                          <span>
                            {{ $t('message.verifyFileFormat') }}
                          </span>
                        </v-tooltip>
                      </span>
                    </template>
                    <template>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="!scope.row.drm_group_ids"
                            class="pl-1"
                            small
                            color="grey"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-lock-open
                          </v-icon>
                          <div v-else>
                            <v-icon
                              v-if="
                                isAnyDrmGroupActive(scope.row.drm_group_ids)
                              "
                              v-bind="attrs"
                              v-on="on"
                              class="pl-1"
                              small
                              color="turquisePanda"
                            >
                              mdi-lock
                            </v-icon>
                            <v-icon
                              v-else
                              v-bind="attrs"
                              v-on="on"
                              class="pl-1"
                              small
                              color="turquisePanda"
                            >
                              mdi-lock-open
                            </v-icon>
                          </div>
                        </template>
                        <span>
                          <v-row v-if="!scope.row.drm_group_ids" no-gutters>
                            <span
                              >Esta pasta não está relacionada a nenhum grupo de
                              segurança</span
                            >
                          </v-row>
                          <v-row
                            no-gutters
                            v-else-if="!drmGroupsLoading"
                            class="flex-column"
                          >
                            <span
                              v-for="drmGroup in scope.row.drm_group_ids"
                              :key="drmGroup.drm_group_id"
                            >
                              <span
                                v-if="findDrmGroupById(drmGroup.drm_group_id)"
                              >
                                <div
                                  v-if="drmGroup.active"
                                  class="
                                    mr-1
                                    pa-1
                                    green
                                    rounded-circle
                                    d-inline-block
                                  "
                                />
                                <div
                                  v-else
                                  class="
                                    mr-1
                                    pa-1
                                    error
                                    rounded-circle
                                    d-inline-block
                                  "
                                />
                                <span>
                                  {{
                                    findDrmGroupById(drmGroup.drm_group_id).name
                                  }}
                                </span>
                              </span>
                            </span>
                          </v-row>
                          <v-row
                            v-else
                            no-gutters
                            align="center"
                            justify="center"
                          >
                            <span class="mr-2">Carregando...</span>
                            <v-progress-circular
                              class="mb-1"
                              size="16"
                              width="3"
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </span>
                      </v-tooltip>
                    </template>
                  </v-row>
                </template>
                <span v-if="isAnyDrmGroupActive(scope.row.drm_group_ids)">
                  {{ $t('message.pages.AbTest.drmVideo') }}
                </span>
              </v-tooltip>
            </template>
            <template v-else>
              <v-row
                no-gutters
                align="center"
                style="max-width: 100%; margin-top: 5px"
                @click="handleClickRowModal(scope.row)"
              >
                <v-icon style="margin: 0px 15px 0px 20px" color="turquisePanda">
                  mdi-play-circle-outline
                </v-icon>
                <span
                  class="text-truncate"
                  :title="scope.row.title"
                  :style="`max-width: ${getTitleWidth(scope.row)};`"
                >
                  {{ scope.row.title }}
                </span>
                <template v-if="scope.row.status === 'DRAFT'">
                  <v-tooltip
                    bottom
                    v-if="
                      Math.abs(new Date(scope.row.created_at) - new Date()) /
                        36e5 >
                      3
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="red--text ml-2 noIbar caption"
                      >
                        <v-icon size="18" color="red">
                          mdi-alert-circle-outline
                        </v-icon>
                      </span>
                    </template>
                    <span>
                      {{ $t('message.processingError') }}
                      {{ $t('message.verifyFileFormat') }}
                    </span>
                  </v-tooltip>
                  <span v-else class="ml-2 secondaryText--text caption noIbar">
                    <v-icon>mdi-progress-upload</v-icon>
                    {{ $t('message.converting') }}...
                  </span>
                </template>
                <span v-if="scope.row.status === 'FAILED'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="red--text ml-2 noIbar caption"
                      >
                        <v-icon size="18" color="red">
                          mdi-alert-circle-outline
                        </v-icon>
                      </span>
                    </template>
                    <span>
                      {{ $t('message.processingError') }}
                      {{ $t('message.verifyFileFormat') }}
                    </span>
                  </v-tooltip>
                </span>
                <template v-if="scope.row.status === 'CONVERTING'">
                  <span
                    v-if="
                      Math.abs(new Date(scope.row.created_at) - new Date()) /
                        36e5 <
                      3
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-on="on"
                          v-bind="attrs"
                          class="ml-2 secondaryText--text caption noIbar"
                        >
                          <v-icon>mdi-progress-upload</v-icon>
                        </span>
                      </template>
                      {{ $t('message.converting') }}...
                    </v-tooltip>
                  </span>
                  <span
                    v-else-if="
                      Math.abs(new Date(scope.row.created_at) - new Date()) /
                        36e5 <
                      48
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-on="on"
                          v-bind="attrs"
                          class="ml-2 text--text caption noIbar"
                        >
                          <v-icon>mdi-progress-upload</v-icon>
                        </span>
                      </template>
                      {{ $t('message.longerThanUsual') }}
                      <span
                        class="primary--text pointer-click"
                        @click="openKnowMoreConverting"
                        >{{ $t('message.knowMore') }} &raquo;
                      </span>
                    </v-tooltip>
                  </span>
                  <span v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                          class="red--text ml-2 noIbar caption"
                        >
                          <v-icon size="18" color="red">
                            mdi-alert-circle-outline
                          </v-icon>
                          {{ $t('message.processingError') }}
                        </span>
                      </template>
                      <span>
                        {{ $t('message.verifyFileFormat') }}
                      </span>
                    </v-tooltip>
                  </span>
                </template>
                <template>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="pl-1"
                        small
                        color="grey"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-lock-open
                      </v-icon>
                    </template>
                    <span>
                      <v-row no-gutters>
                        <span
                          >Esta pasta não está relacionada a nenhum grupo de
                          segurança</span
                        >
                      </v-row>
                    </span>
                  </v-tooltip>
                </template>
              </v-row>
            </template>
          </v-row>
        </template>
        <template slot-scope="scope" slot="sizeCommom">
          <v-row no-gutters justify="center">
            <div v-if="!!scope.row.type"></div>
            <span
              class="text-righ pl-0"
              :style="getRowStyle(scope.row)"
              v-else-if="
                scope.row.storage_size &&
                (scope.row.status === 'CONVERTED' ||
                  scope.row.status === 'CONVERTING')
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{
                      scope.row.storage_size > 0.01
                        ? removeDotIfItExists(
                            calcMegabytes(scope.row.storage_size, 'B')
                          )
                        : ''
                    }}
                  </span>
                </template>
                <span
                  >{{ $t('message.storageTooltip') }} <br />
                  {{ $t('message.storageTooltip2') }}<br />
                  {{ $t('message.storageTooltip3') }}</span
                >
              </v-tooltip>
            </span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="timeCommom">
          <v-row no-gutters justify="center">
            <div v-if="!!scope.row.type"></div>
            <span
              class="text-right"
              :style="getRowStyle(scope.row)"
              v-else-if="
                scope.row['length'] &&
                (scope.row.status === 'CONVERTED' ||
                  scope.row.status === 'CONVERTING')
              "
            >
              {{ formatTime(scope.row['length']) }}
            </span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="lastModifiedCommom">
          <v-row no-gutters justify="center">
            <div v-if="!!scope.row.type"></div>
            <span class="text-center" :style="getRowStyle(scope.row)" v-else>
              {{
                new Date(scope.row.updated_at)
                  .toLocaleString('pt-BR')
                  .slice(0, 3) +
                new Date(scope.row.updated_at)
                  .toLocaleString(localeString, { month: 'long' })
                  .slice(0, 3) +
                '/' +
                new Date(scope.row.updated_at)
                  .toLocaleString('pt-BR')
                  .slice(6, 10)
              }}
            </span>
          </v-row>
        </template>
      </vue-virtual-table>

      <div v-else-if="videoToBeAdded">
        <v-btn text @click="videoToBeAdded = null" class="px-2 ml-6">
          <v-icon class="mr-3" size="18" color="primary">mdi-arrow-left</v-icon>
          <span class="headerTitle primary--text">{{
            $t('message.pages.video.back')
          }}</span>
        </v-btn>
        <v-card flat>
          <div
            v-if="videoToBeAdded.status === 'CONVERTED'"
            class="iframe mx-6 mt-4 d-flex justify-center"
            style="position: relative; padding-top: 41.25%"
          >
            <iframe
              id="panda-player"
              :src="`${videoToBeAdded.video_player}&isDashboard=true`"
              style="
                border: none;
                position: absolute;
                top: 0;
                width: 79%;
                height: 100%;
              "
            >
            </iframe>
          </div>
          <v-card class="my-3 mx-6" v-else>
            <v-row class="mb-2">
              <v-col
                cols="12"
                class="text-center"
                style="
                  padding-top: 20.625% !important;
                  padding-bottom: 20.625% !important;
                "
              >
                <span class="text-center" style="font-size: 12px">
                  {{ $t('message.pages.videoEditModal.videoConvertingText2') }}
                  <br />
                  {{ $t('message.pages.videoEditModal.videoConvertingText3') }}
                </span>
                <br />
                <v-progress-circular
                  indeterminate
                  :size="16"
                  :width="3"
                  color="brand"
                  class="mt-4"
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <v-alert
          class="mx-6 mt-4"
          colored-border
          type="warning"
          border="left"
          elevation="1"
          icon="mdi-alert"
          style="font-size: 11px"
        >
          {{ $t('message.pages.AbTest.videoWithData') }}
        </v-alert>
      </div>
      <div v-else :style="`height: ${tableHeight - 48}px`" class="mr-5 ml-7">
        <v-container fill-height class="mt-0">
          <v-row
            class="d-flex flex-column"
            no-gutters
            justify="center"
            align="center"
          >
            <img
              v-if="$vuetify.theme.dark"
              class="ml-4"
              src="@/assets/pandaLogo.svg"
              max-width="180"
            />
            <img
              v-else
              class="ml-4"
              src="@/assets/pandaHappy.svg"
              max-width="180"
            />
            <span class="noFilesAddedText">{{
              $t('message.pages.AbTest.noVideosInFolder')
            }}</span>
          </v-row>
        </v-container>
      </div>

      <v-card-actions class="px-8 pb-6">
        <v-spacer></v-spacer>
        <v-tooltip v-if="isItAlreadyInTheTest && videoToBeAdded" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="mr-2">
              <v-btn color="primary" outlined disabled>
                {{ $t('message.pages.AbTest.add') }}
              </v-btn>
            </div>
          </template>
          <span>{{ $t('message.pages.AbTest.videoAlreadyInAbTest') }}</span>
        </v-tooltip>
        <v-btn
          v-else-if="videoToBeAdded"
          color="primary"
          outlined
          :loading="loadings.isAddingVideo"
          :disabled="loadings.isAddingVideo || loadings.isDuplicatingVideo"
          @click="handleAddVideoToTest"
        >
          {{ $t('message.pages.AbTest.add') }}
        </v-btn>
        <v-btn
          @click="handleDuplicate"
          color="primary"
          v-if="videoToBeAdded"
          class="mr-4 px-4 white--text"
          :disabled="loadings.isDuplicatingVideo || loadings.isAddingVideo"
          :loading="loadings.isDuplicatingVideo"
        >
          {{ $t('message.pages.AbTest.duplicate') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import calcMegabytesMixin from '@/utils/calcMegabytes'
import foldersApi from '@/services/foldersApi'
import Storage from '@/utils/Storage'
import videosApi from '@/services/videosApi'
import i18n from '@/translations/lang'
import VueVirtualTable from 'vue-virtual-table'
import LoadingLogo from '@/components/LoadingLogo.vue'
import drmApi from '@/services/drmApi'
import formatTimeMixin from '@/utils/formatTime.mixins.js'

export default {
  name: 'AddVideo',
  components: { VueVirtualTable, LoadingLogo },
  props: {
    openAddVideo: {
      type: Boolean,
      required: true,
      default: false,
    },
    comparisonVideos: {
      type: Array,
      required: true,
    },
  },
  mixins: [calcMegabytesMixin, formatTimeMixin],
  data: () => ({
    tableHeight: window.innerHeight - 180,
    isBeta: false,
    videoToBeAdded: null,
    breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
    loadedVideos: [],
    loadedFolders: [],
    allVideos: [],
    lastFolder: {
      id: null,
    },
    currentRoute: {
      id: null,
    },
    loadings: {
      isHotReloading: false,
      isLoadingModalVideos: true,
      isDuplicatingVideo: false,
      isAddingVideo: false,
    },
    listQuery: {
      root_folder: 1,
      page: 1,
      limit: 5000,
      status: undefined,
      title: undefined,
      folder_id: null,
    },
    videosTableConfig: [
      {
        prop: '_action',
        name: i18n.t('message.name'),
        actionName: 'titleCommon',
        width: 300,
        alignItems: 'start',
      },
      {
        prop: '_action',
        name: i18n.t('message.size'),
        actionName: 'sizeCommom',
        sortable: true,
        width: 100,
        alignItems: 'center',
      },
      {
        prop: '_action',
        actionName: 'timeCommom',
        name: i18n.t('message.time'),
        width: 100,
        alignItems: 'center',
      },
      {
        prop: '_action',
        actionName: 'lastModifiedCommom',
        name: i18n.t('message.lastModification'),
        sortable: true,
        width: 100,
        alignItems: 'center',
      },
    ],
    isDrmActive: false,
    drmGroups: false,
    drmGroupsLoading: true,
  }),
  watch: {
    openAddVideo(value) {
      if (!value) {
        this.loadings.isDuplicatingVideo = false
        this.loadings.isAddingVideo = false
        this.videoToBeAdded = null
      }
    },
  },
  computed: {
    ...mapState({
      mainFolders: (state) => state.user.mainFolders,
    }),
    isItAlreadyInTheTest() {
      if (!this.videoToBeAdded?.id) return false
      const videoArray = this.comparisonVideos.filter(
        ({ id }) => id === this.videoToBeAdded.id
      )
      if (videoArray.length > 0) return true
      return false
    },
    localeString() {
      return this.$i18next.resolvedLanguage === 'pt' ? 'pt-BR' : 'en-US'
    },
    allItems() {
      return this.loadedFolders.concat(this.filteredVids)
    },
    filteredVids() {
      return this.loadedVideos.filter((video) => video.status != 'DELETING')
    },
    rootFolders() {
      return this.mainFolders.filter((folder) => {
        return folder.parent_folder_id === null
      })
    },
    open: {
      get() {
        return this.openAddVideo
      },
      set(newValue) {
        if (!newValue) this.$emit('close')
      },
    },
    reducedBreadcrumbArray() {
      let arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })
      if (this.currentRoute.id) {
        return this.breadcrumbArray
      }
      return arrayMod
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
  },
  async created() {
    this.isBeta = location.search.match('beta')
    this.$root.$on(
      'forceStopAddVideoLoading',
      () => (this.loadings.isDuplicatingVideo = false)
    )
    this.$root.$on('reloadAddVideoModalVideos', async () => {
      if (this.$route.name === 'NewTest') {
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
        await this.pageRequests(false)
      }
    })
    if (!this.loadings.isHotReloading) {
      await this.pageRequests()
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeTimeout)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTimeout)
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_MAIN_FOLDERS',
      'UPDATE_ALL_FOLDERS',
      'UPDATE_DELETED_FOLDERS',
      'UPDATE_DID_FETCH_VIDEOS',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    resizeTimeout() {
      clearTimeout(this.resizeWindowTimeout)
      this.resizeWindowTimeout = setTimeout(() => {
        this.tableHeight = window.innerHeight - 180
      }, 300)
    },
    getTitleWidth(item) {
      if (item.status === 'CONVERTED') {
        return '239px'
      }
      if (item.status === 'CONVERTING') {
        return '119px'
      }
      if (
        item.status === 'DRAFT' &&
        !(Math.abs(new Date(item.created_at) - new Date()) / 36e5 > 3)
      ) {
        return '119px'
      }
      // folders width below
      return '221px'
    },
    getRowStyle(item) {
      if (
        item.drm_group_ids &&
        this.isAnyDrmGroupActive(item.drm_group_ids) &&
        !item.name
      ) {
        return 'color: grey;'
      }
      return ''
    },
    async getDrmGroups() {
      this.drmGroupsLoading = true
      try {
        let ret = await drmApi.getDrmGroups()
        this.isDrmActive = true
        this.drmGroups = ret.data
      } catch (error) {
        this.drmGroupsLoading = false
        if (error.response.data.errMsg.includes('Drm is not active')) {
          this.isDrmActive = false
          return
        }
        setTimeout(() => {
          this.getDrmGroups()
        }, 2000)
      }
      this.drmGroupsLoading = false
    },
    isAnyDrmGroupActive(ids) {
      if (!ids || !Object.keys(ids).length) return false
      return ids.some((id) => id.active)
    },
    findDrmGroupById(id) {
      let foundGroup = this.drmGroups.find((el) => el.id === id)
      return foundGroup
    },
    handleBackTo(backToFolder) {
      if (backToFolder.id === this.currentRoute.id) return
      this.currentRoute = { id: backToFolder.id }
      this.checkAndSearch()
      this.lastFolder = backToFolder
      if (!backToFolder.id) {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        return
      }
      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
          backToFolder.id
      )
        return
      let index = this.breadcrumbArray.findIndex((folder) => {
        return folder.id === backToFolder.id
      })
      let newArr = this.breadcrumbArray.slice(0, index + 1)
      this.breadcrumbArray = newArr
    },
    handleAddVideoToTest() {
      this.loadings.isAddingVideo = true
      this.$emit('handleAddVideoToTest', this.videoToBeAdded)
    },
    handleDuplicate() {
      this.loadings.isDuplicatingVideo = true
      this.$emit('handleDuplicate', this.videoToBeAdded)
    },
    handleClickRowModalFolder(item) {
      this.lastFolder = this.currentRoute
      this.breadcrumbArray.push(item)
      this.currentRoute = item
      this.checkAndSearch()
    },
    handleClickRowModal(item) {
      this.videoToBeAdded = item
    },
    removeDotIfItExists(value) {
      let dotIndex = value.indexOf('.')
      if (dotIndex === -1) return value
      return value.slice(0, dotIndex) + value.slice(dotIndex + 2, value.length)
    },
    getInsideItemsQuantity(searchedFolder) {
      let folders = this.mainFolders.filter((folder) => {
        return folder.parent_folder_id === searchedFolder.id
      })
      if (!searchedFolder.videos_count && folders.length)
        return `(${folders.length})`
      if (!folders.length && searchedFolder.videos_count < 1) return '(0)'
      let size =
        parseInt(folders.length) + parseInt(searchedFolder.videos_count)
      return size ? `(${size})` : '(0)'
    },
    isNamesTooBig() {
      let size = 0
      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }
      if (this.currentRoute?.name) {
        size += this.currentRoute.name.length
      }
      return size > 40
    },
    async checkAndSearch(mustReload = true) {
      this.loadings.isLoadingModalVideos = mustReload
      document.body.style.cursor = 'wait'
      if (!this.mainFolders.length) {
        this.loadings.isLoadingModalVideos = mustReload
        await this.readUserFolders()
      }
      if (this.currentRoute.id) {
        this.listQuery.folder_id = this.currentRoute.id
      } else {
        this.listQuery.folder_id = null
        this.listQuery.root_folder = 1
      }
      let totalLength = await window.db.videos.count()
      let deletedLength = 0
      try {
        deletedLength = await window.db.videos
          .where({ status: 'DELETING' })
          .count()
      } catch (e) {
        await window.db.videos.delete(
          `panda-${this.$store.state.user.userInfo.sub ?? this.getSubKey()}`
        )
        this.UPDATE_DID_FETCH_VIDEOS(false)
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
        this.pageRequests(mustReload)
      }
      window.dbVideosLength = totalLength - deletedLength
      await this.setPageVideos()
      this.loadings.isLoadingModalVideos = false
    },
    async setPageVideos() {
      let pageVideos = []
      if (this.currentRoute.id === null) {
        pageVideos = await window.db.videos
          .where({ folder_id: 'root' })
          .limit(50)
          .toArray()
      } else {
        pageVideos = await window.db.videos
          .where({ folder_id: this.listQuery.folder_id })
          .limit(50)
          .toArray()
      }
      let folderFolders = []
      if (this.currentRoute.id) {
        folderFolders = this.mainFolders.filter((folder) => {
          if (this.currentRoute.id === null) {
            return folder.parent_folder_id === null
          } else {
            return folder.parent_folder_id === this.currentRoute.id
          }
        })
      } else {
        folderFolders = this.rootFolders
      }
      this.loadedFolders = folderFolders
      this.allVideos = pageVideos.filter(
        (video) =>
          video.status !== 'DELETING' && !video.hasOwnProperty('video_source')
      )
      this.loadedVideos = this.allVideos
      setTimeout(() => {
        this.getFolderInfo(this.currentRoute.id)
      }, 200)
      document.body.style.cursor = 'default'
      setTimeout(async () => {
        let newConcatArray = []
        if (pageVideos.length > 49) {
          if (this.currentRoute.id === null) {
            newConcatArray = await window.db.videos
              .where({ folder_id: 'root' })
              .offset(50)
              .toArray()
          } else {
            newConcatArray = await window.db.videos
              .where({ folder_id: this.listQuery.folder_id })
              .offset(50)
              .toArray()
          }
        }
        this.loadedVideos.push(...newConcatArray)
      }, 2000)
    },
    getFolderInfo(id) {
      this.folder = this.findFolderById(id)
      if (this.folder?.parent_folder_id) {
        this.lastFolder = this.findFolderById(this.folder.parent_folder_id)
      } else {
        this.lastFolder = {
          name: '',
          updated_at: '',
          created_at: '',
          parent_folder_id: '',
          videos: [],
          id: '',
        }
      }
    },
    findFolderById(id) {
      return this.mainFolders.find((folder) => {
        return folder.id === id
      })
    },
    async pageRequests(mustReload = true) {
      if (!mustReload) {
        this.loadings.isHotReloading = true
      } else {
        this.loadings.isHotReloading = false
      }
      if (this.$route.name !== 'NewTest') return
      if (!window.db) {
        this.$root.$emit('initDexie')
      }
      this.loadings.isLoadingModalVideos = mustReload
      if (
        !this.$store.state.user.didFetchVideos ||
        this.$store.state.user.shouldFetchAllVideos
      ) {
        await this.readUserFolders()
        await this.getAllAccountVideos(!mustReload)
        this.UPDATE_DID_FETCH_VIDEOS(true)
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(false)
      }
      this.checkAndSearch(mustReload)
      if (this.isBeta) {
        this.getDrmGroups()
      }
    },
    async getAllAccountVideos(mustPopulate = false) {
      try {
        const { data } = await videosApi.getAllVideosAndBin()
        let filteredFoldersIds = []
        let videosResponse = data.videos
        for (let folderId in videosResponse) {
          filteredFoldersIds.push(folderId)
        }
        await window.db.videos.clear()
        let allVideos = []
        for (let folderId of filteredFoldersIds) {
          let arrToBeAdded = data.videos[folderId].map((obj) => ({
            ...obj,
            folder_id: folderId,
          }))
          allVideos = [...allVideos, ...data.videos[folderId]]
          await window.db.videos.bulkPut(arrToBeAdded)
        }
        if (mustPopulate) {
          this.$root.$emit('addVideoVideosUpdatedList', allVideos)
        }
      } catch (error) {
        console.error(error)
        this.loadings.isLoadingModalVideos = false
      }
    },
    getSubKey() {
      let subKey = null
      let keys = Storage.getStorageKeys()
      for (let key of keys) {
        if (key[0].includes('LastAuthUser')) {
          subKey = key[1]
        }
      }
      return subKey
    },
    async readUserFolders() {
      try {
        let ret = await foldersApi.getUserFolders()
        let notDeletedFolders = ret.data.folders.filter(
          (folder) => folder.status != false
        )
        let deletedFolders = ret.data.folders.filter(
          (folder) => folder.status === false
        )
        this.UPDATE_MAIN_FOLDERS(notDeletedFolders)
        this.UPDATE_DELETED_FOLDERS(deletedFolders)
        this.UPDATE_ALL_FOLDERS(ret.data.folders)
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>

<style>
.t-header {
  display: none;
}

.t-header span {
  font-weight: bold;
}

.videoModalList {
  overflow-x: hidden !important;
}
</style>

<style scoped>
div.item-cell-inner.rowSlot {
  align-items: center !important;
}
</style>
